import { FrustratedPenguinAndErrorDocument } from "@illustrations";

import { ErrorDisplay } from "./error-display";

interface NotFoundErrorPropType {
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function GenericError({
  message,
  actionLabel,
  onAction,
}: NotFoundErrorPropType) {
  return (
    <ErrorDisplay
      message={message}
      defaultTranslationKey="genericErrorMessage"
      Illustration={<FrustratedPenguinAndErrorDocument />}
      actionLabel={actionLabel}
      onAction={onAction}
    />
  );
}
